export const DownloadIcon = (): JSX.Element => {
  return (
    <svg width="24" height="24" fill="none">
      <path
        d="M19.475 12.82H8.285c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h11.19c.45 0 .81.36.81.81 0 .45-.36.81-.81.81Z"
        fill="#302C41"
      />
      <path
        d="M16.265 16.51c-.21 0-.42-.08-.57-.24a.809.809 0 0 1 0-1.15l3.11-3.11-3.11-3.11a.809.809 0 0 1 0-1.15c.32-.32.83-.32 1.15 0l3.69 3.69c.15.15.24.36.24.57 0 .21-.09.42-.24.57l-3.69 3.69c-.16.16-.37.24-.57.24h-.01ZM8.345 8.79h-4.27a.811.811 0 0 1-.74-1.14c.06-.14.15-.26.25-.37l4.48-4.48c.1-.1.21-.18.35-.24.25-.12.54-.1.78.05.23.15.38.41.38.69v4.27c0 .68-.55 1.23-1.23 1.23v-.01Zm-2.34-1.63h1.95V5.22l-1.95 1.94Z"
        fill="#302C41"
      />
      <path
        d="M17.155 21.57h-12.7c-.68 0-1.23-.55-1.23-1.23V8.14c0-.18.04-.35.12-.52.13-.28.42-.47.73-.47h3.87V3.28c0-.32.19-.61.48-.74.16-.07.33-.11.51-.11h8.22c.68 0 1.23.55 1.23 1.23v1.67c0 .45-.36.81-.81.81-.45 0-.81-.36-.81-.81V4.06h-7.18v3.49c0 .68-.55 1.23-1.23 1.23h-3.49v11.16h11.9v-1.27c0-.45.36-.81.81-.81.45 0 .81.36.81.81v1.67c0 .68-.55 1.23-1.23 1.23Z"
        fill="#302C41"
      />
    </svg>
  )
}
